import { cn } from "@/lib/utils";

export interface TemplateStudioStatusPillProps {
  isWorking: boolean;
}

/**
 * Ready / Working status pill for Template Studio top nav.
 */
export const TemplateStudioStatusPill = ({
  isWorking,
}: TemplateStudioStatusPillProps) => (
  <span
    role="status"
    className={cn(
      "inline-flex items-center gap-1.5 px-2 py-0.5 text-[11px]",
      isWorking ? "text-violet-800" : "text-gray-500",
    )}
    aria-live="polite"
  >
    <span
      className={cn(
        "size-1.5 shrink-0 rounded-full",
        isWorking ? "animate-pulse bg-violet-800" : "bg-green-500",
      )}
      aria-hidden
    />
    {isWorking ? "Working" : "Ready"}
  </span>
);
